import { formatDate } from 'lib/helpers/dateUtils';

import Avatar from 'components/shared/Avatar/Avatar';
import Dot from 'components/shared/Dot/Dot';
import Icon from 'components/shared/Icon/Icon';
import Typography from 'components/shared/Typography/Typography';

const formatLocation = (location) => {
  if (!location) return '';
  return location.replace(/_/g, '-').replace(/^./, (str) => str.toUpperCase());
};

const DetailItem = ({ icon, value, color = 'neutral' }) => {
  return (
    <div className="flex items-center gap-1">
      {icon && <Icon icon={icon} size={16} color={color} shadow={700} />}
      <Typography variant="p" size="xs" weight="medium" color="neutral-700">
        {value}
      </Typography>
    </div>
  );
};

const UpcomingAppointment = ({ appointment, timezone }) => {
  return (
    <div className=" flex h-[90px] w-full items-center gap-3 rounded-md border border-solid border-neutral-200 bg-white px-3 py-2.5 md:max-w-[330px]">
      <div className="flex flex-col justify-center gap-2">
        <div className="flex items-center gap-1.5">
          <Avatar
            size="large"
            fullName={appointment?.practitioner?.fullName}
            id={appointment?.practitioner?.id}
          />
          <div className="flex flex-col justify-center">
            <Typography variant="p" size="small" weight="medium" color="neutral-800">
              {appointment?.practitioner?.title && `${appointment?.practitioner?.title} `}
              {appointment?.practitioner?.fullName}
            </Typography>
            {appointment?.practitioner?.profession && (
              <div className="h-4">
                <Typography variant="p" size="small" weight="normal" color="neutral-700">
                  {appointment?.practitioner?.profession}
                </Typography>
              </div>
            )}
          </div>
        </div>
        <div className="flex items-center gap-1.5">
          <DetailItem icon="calendar-mono" value={formatDate(appointment?.starts_at, timezone)} />
          <Dot size="xs" color="neutral" />
          <DetailItem value={formatDate(appointment?.starts_at, timezone, 'h:mm a')} />
          {appointment?.location && (
            <>
              <Dot size="xs" color="neutral" />
              <DetailItem icon="users-mono" value={formatLocation(appointment?.location)} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpcomingAppointment;
